export const BASE_URL = 'form-submissions';

